(function (global) {
  'use strict';
  if (global.__coPerformanceRuntime) return;
  global.__coPerformanceRuntime = true;

  function idle(callback) {
    if (typeof global.requestIdleCallback === 'function') {
      global.requestIdleCallback(callback, { timeout: 2500 });
    } else {
      global.setTimeout(callback, 1200);
    }
  }

  function loadScript(id, source) {
    if (global.document.getElementById(id)) return;
    var script = global.document.createElement('script');
    script.id = id;
    script.async = true;
    script.src = source;
    global.document.head.appendChild(script);
  }

  function privacyAllows(kind) {
    var privacy = global.Shopify && global.Shopify.customerPrivacy;
    if (!privacy) return false;
    try {
      if (kind === 'analytics') return privacy.analyticsProcessingAllowed() === true;
      if (kind === 'marketing') return privacy.marketingAllowed() === true;
    } catch (error) {}
    return false;
  }

  function loadGtmAndHotjar() {
    if (global.__coAnalyticsLoaded || !privacyAllows('analytics') || !privacyAllows('marketing')) return;
    global.__coAnalyticsLoaded = true;
    global.dataLayer = global.dataLayer || [];
    global.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    loadScript('co-gtm-loader', 'https://www.googletagmanager.com/gtm.js?id=GTM-K2CCQXX3');
    global.hj = global.hj || function () { (global.hj.q = global.hj.q || []).push(arguments); };
    global._hjSettings = { hjid: 3600221, hjsv: 6 };
    loadScript('co-hotjar-loader', 'https://static.hotjar.com/c/hotjar-' + global._hjSettings.hjid + '.js?sv=' + global._hjSettings.hjsv);
  }

  function loadTikTok() {
    if (global.__coMarketingLoaded || !privacyAllows('marketing')) return;
    global.__coMarketingLoaded = true;
    var name = 'ttq';
    global.TiktokAnalyticsObject = name;
    var queue = global[name] = global[name] || [];
    queue.methods = ['page','track','identify','instances','debug','on','off','once','ready','alias','group','enableCookie','disableCookie'];
    queue.setAndDefer = function (target, method) {
      target[method] = function () { target.push([method].concat(Array.prototype.slice.call(arguments))); };
    };
    queue.methods.forEach(function (method) { queue.setAndDefer(queue, method); });
    queue.load = function (pixel) {
      loadScript('co-tiktok-loader', 'https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=' + pixel + '&lib=' + name);
    };
    queue.load('CLFURJJC77U022B48HF0');
    queue.page();
  }

  function scheduleAllowedThirdParties() {
    idle(function () {
      loadGtmAndHotjar();
      loadTikTok();
    });
  }

  function preparePrivacy() {
    global.document.addEventListener('visitorConsentCollected', scheduleAllowedThirdParties);
    if (global.Shopify && typeof global.Shopify.loadFeatures === 'function') {
      global.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) scheduleAllowedThirdParties();
      });
    }
  }

  function hydrateMedia(image) {
    if (!image || !image.dataset || !image.dataset.coSrc) return;
    var media = image.closest('[data-product-single-media-wrapper]');
    if (media && media.classList.contains('is--media-hide')) return;
    var gallery = media && media.closest('[data-main-media]');
    var galleryOptions = gallery && gallery.getAttribute('data-flickityt4s-js');
    var usesSingleActiveSlide = galleryOptions && /"thumbNav"\s*:\s*true/.test(galleryOptions);
    if (usesSingleActiveSlide && !media.classList.contains('is-selected')) return;
    image.dataset.src = image.dataset.coSrc;
    delete image.dataset.coSrc;
    image.classList.remove('co-media-inert');
    image.classList.add('lazyloadt4s');
    if (global.lazySizes && global.lazySizes.loader) global.lazySizes.loader.unveil(image);
  }

  function hydrateRelevantProductMedia(root) {
    (root || global.document).querySelectorAll('img[data-co-src]').forEach(hydrateMedia);
  }

  function sizedImageUrl(master, width) {
    try {
      var url = new global.URL(master, global.location.href);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (error) {
      return master;
    }
  }

  function promoteVisibleProductHero(root) {
    var scope = root || global.document;
    var galleries = scope.matches && scope.matches('[data-main-media]') ? [scope] : scope.querySelectorAll('[data-main-media]');
    galleries.forEach(function (gallery) {
      var selectedSlide = gallery.querySelector('[data-main-slide].is-selected:not(.is--media-hide)');
      var image = selectedSlide ? selectedSlide.querySelector('img') :
        gallery.querySelector('[data-main-slide]:not(.is--media-hide) img[data-master]');
      if (!image) return;
      image.loading = 'eager';
      image.fetchPriority = 'high';
      image.setAttribute('fetchpriority', 'high');
      var master = image.getAttribute('data-master');
      if (master && !image.classList.contains('co-product-lcp')) {
        var widths = [400, 600, 800, 1000, 1200, 1400, 1600];
        var markImageVisible = function () {
          image.classList.remove('lazyloadt4sing');
          image.classList.add('lazyloadt4sed');
        };
        image.addEventListener('load', markImageVisible, { once: true });
        image.sizes = '(min-width: 1500px) 750px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 2rem)';
        image.srcset = widths.map(function (width) { return sizedImageUrl(master, width) + ' ' + width + 'w'; }).join(', ');
        image.src = sizedImageUrl(master, 800);
        delete image.dataset.coSrc;
        delete image.dataset.src;
        image.classList.remove('co-media-inert', 'lazyloadt4s', 'lazyloading');
        if (image.complete && image.naturalWidth > 1) markImageVisible();
      }
    });
  }

  function observeProductMedia() {
    promoteVisibleProductHero(global.document);
    hydrateRelevantProductMedia(global.document);
    if (typeof global.MutationObserver !== 'function') return;
    var observer = new global.MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'attributes') {
          hydrateRelevantProductMedia(record.target);
          promoteVisibleProductHero(record.target.closest('[data-main-media]') || global.document);
          syncMediaAccessibility(record.target);
        }
      });
    });
    global.document.querySelectorAll('[data-product-single-media-wrapper]').forEach(function (media) {
      syncMediaAccessibility(media);
      observer.observe(media, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
    });
    global.document.addEventListener('variant:changed', function () {
      hydrateRelevantProductMedia(global.document);
      promoteVisibleProductHero(global.document);
    });
  }

  function matchingNodes(root, selector) {
    var scope = root || global.document;
    var result = [];
    if (scope.nodeType === 1 && scope.matches(selector)) result.push(scope);
    if (scope.querySelectorAll) result = result.concat(Array.prototype.slice.call(scope.querySelectorAll(selector)));
    return result;
  }

  function syncMediaAccessibility(media) {
    if (!media || !media.matches || !media.matches('[data-product-single-media-wrapper]')) return;
    media.inert = media.getAttribute('aria-hidden') === 'true' || media.classList.contains('is--media-hide');
  }

  function repairAccessibility(root) {
    var language = (global.document.documentElement.lang || 'en').slice(0, 2);
    var copy = {
      en: ['Open menu', 'Decrease quantity', 'Increase quantity', 'Quantity', 'View product', 'CarOptions home'],
      de: ['Menü öffnen', 'Menge verringern', 'Menge erhöhen', 'Menge', 'Produkt ansehen', 'CarOptions Startseite'],
      fr: ['Ouvrir le menu', 'Diminuer la quantité', 'Augmenter la quantité', 'Quantité', 'Voir le produit', 'Accueil CarOptions'],
      es: ['Abrir menú', 'Reducir cantidad', 'Aumentar cantidad', 'Cantidad', 'Ver producto', 'Inicio CarOptions'],
      it: ['Apri menu', 'Riduci quantità', 'Aumenta quantità', 'Quantità', 'Vedi prodotto', 'Home CarOptions'],
      pl: ['Otwórz menu', 'Zmniejsz ilość', 'Zwiększ ilość', 'Ilość', 'Zobacz produkt', 'Strona główna CarOptions'],
      sv: ['Öppna meny', 'Minska antal', 'Öka antal', 'Antal', 'Visa produkt', 'CarOptions startsida'],
      da: ['Åbn menu', 'Reducer antal', 'Øg antal', 'Antal', 'Se produkt', 'CarOptions forside'],
      fi: ['Avaa valikko', 'Vähennä määrää', 'Lisää määrää', 'Määrä', 'Näytä tuote', 'CarOptions etusivu'],
      no: ['Åpne meny', 'Reduser antall', 'Øk antall', 'Antall', 'Vis produkt', 'CarOptions forside']
    }[language] || ['Open menu', 'Decrease quantity', 'Increase quantity', 'Quantity', 'View product', 'CarOptions home'];

    matchingNodes(root, 'a.t4s-push-menu-btn').forEach(function (link) { if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', copy[0]); });
    matchingNodes(root, 'button.t4s-quantity-selector').forEach(function (button) {
      if (!button.getAttribute('aria-label')) button.setAttribute('aria-label', button.hasAttribute('data-decrease-qty') ? copy[1] : copy[2]);
    });
    matchingNodes(root, 'input.t4s-quantity-input').forEach(function (input) { if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', copy[3]); });
    matchingNodes(root, '.call_adviser_status[aria-label]').forEach(function (status) { if (!status.getAttribute('role')) status.setAttribute('role', 'img'); });
    matchingNodes(root, 'img:not([alt])').forEach(function (image) { image.setAttribute('alt', ''); });
    matchingNodes(root, '.copv__title').forEach(function (heading) { heading.setAttribute('role', 'heading'); heading.setAttribute('aria-level', '2'); });
    matchingNodes(root, '.t4s-footer-content > a.t4s-d-block').forEach(function (link) { if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', copy[5]); });
    matchingNodes(root, 'a.t4s-full-width-link').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href) {
        var replacement = global.document.createElement('span');
        replacement.className = link.className;
        replacement.setAttribute('style', link.getAttribute('style') || '');
        replacement.setAttribute('aria-hidden', 'true');
        link.replaceWith(replacement);
        return;
      }
      if (link.getAttribute('aria-label') || link.textContent.trim() || link.querySelector('img[alt]:not([alt=""])')) return;
      var product = link.closest('.t4s-product');
      var title = product && product.querySelector('.t4s-product-title, [data-product-title]');
      link.setAttribute('aria-label', title && title.textContent.trim() ? title.textContent.trim() : copy[4]);
    });
    matchingNodes(root, '[data-product-single-media-wrapper]').forEach(syncMediaAccessibility);
  }

  function observeAccessibility() {
    repairAccessibility(global.document);
    if (typeof global.MutationObserver !== 'function' || !global.document.body) return;
    var observer = new global.MutationObserver(function (records) {
      records.forEach(function (record) {
        Array.prototype.forEach.call(record.addedNodes || [], function (node) { if (node.nodeType === 1) repairAccessibility(node); });
      });
    });
    observer.observe(global.document.body, { childList: true, subtree: true });
  }

  function observeVitals() {
    if (typeof global.PerformanceObserver !== 'function') return;
    var values = global.coPerformanceVitals = global.coPerformanceVitals || { cls: 0 };
    try {
      new global.PerformanceObserver(function (list) {
        var entries = list.getEntries();
        var last = entries[entries.length - 1];
        if (last) values.lcp = Math.round(last.startTime);
      }).observe({ type: 'largest-contentful-paint', buffered: true });
      new global.PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) { if (!entry.hadRecentInput) values.cls += entry.value; });
      }).observe({ type: 'layout-shift', buffered: true });
      new global.PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          var duration = entry.duration || 0;
          if (!values.inp || duration > values.inp) values.inp = Math.round(duration);
        });
      }).observe({ type: 'event', buffered: true, durationThreshold: 40 });
    } catch (error) {}
    global.addEventListener('pagehide', function () {
      global.document.dispatchEvent(new CustomEvent('co:performance-vitals', { detail: values }));
      if (global.dataLayer && global.__coAnalyticsLoaded) global.dataLayer.push({ event: 'co_web_vitals', webVitals: values });
    });
  }

  function boot() {
    preparePrivacy();
    observeProductMedia();
    observeAccessibility();
    observeVitals();
  }

  if (global.document.readyState === 'loading') global.document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})(window);
